import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[trimSpace]' })
export class TrimSpaceDirective {

  constructor(private el: ElementRef) { }

  @HostListener('blur') onBlur() {
    const value = this.el.nativeElement.value;
    const valueTrim = value.trim();
    if (value !== valueTrim) { this.el.nativeElement.value = valueTrim; }
  }

}

@Directive({ selector: '[alphabets]' })
export class AlphabetsDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[alphabetsWithSpace]' })
export class AlphabetsWithSpaceDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z ]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[alphabetsWithSpaceComma]' })
export class AlphabetsWithSpaceCommaDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z ,]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[alphaNumeric]' })
export class AlphaNumericDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z0-9]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[alphaNumericWithSH]' })
export class AlphaNumericWithSHDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z0-9 -]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[alphaNumericWithSHC]' })
export class AlphaNumericWithSHCDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const regEx = /[^a-zA-Z0-9 -,]/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}
